import { useEffect } from "react";

const BASE_URL = "https://redwing.app";

const setMetaContent = (selector: string, content: string) => {
  const element = document.head.querySelector<HTMLMetaElement>(selector);
  if (element) {
    element.setAttribute("content", content);
  }
};

/**
 * Sets the document title, meta description, canonical URL and the matching
 * Open Graph / Twitter tags for a page. Values are picked up by crawlers that
 * execute JavaScript and by users bookmarking/sharing the page.
 */
const usePageMeta = (title: string, description: string, path: string) => {
  useEffect(() => {
    document.title = title;
    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[name="twitter:title"]', title);
    setMetaContent('meta[name="twitter:description"]', description);

    const url = `${BASE_URL}${path}`;
    setMetaContent('meta[property="og:url"]', url);
    const canonical = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]'
    );
    if (canonical) {
      canonical.setAttribute("href", url);
    }
  }, [title, description, path]);
};

export default usePageMeta;
